const route = {
  routeCode: 'RouteCode',
  shipDcNo: 'ShipDcNo',
  carrierNo: 'CarrierNo',
  transitTime: 'TransitTime',
  receiptReturnTime: 'ReceiptReturnTime',
  msg: {}
};
export default route;



// WEBPACK FOOTER //
// ./src/page/md/route/lang/route.en.js